module.exports = __webpack_public_path__ + "img/ppt.37dc4b4a.svg";